import dateConvert from "common/helper/dateConvert";

const parseDate = function(millis) {
    return millis ? dateConvert.toDateUsingClientsTimeZone(millis) : undefined;
};

export default kendo.data.Model.define({

    fields: {

        companyName: {
            type: "string"
        },

        instantIssued: {
            type: "date",
            parse: parseDate
        },

        instantExpires: {
            type: "date",
            parse: parseDate
        },

        maxUsers: {
            type: "number"
        },

        modules: {
            defaultValue: []
        },

        billingEmail: {
            type: "string"
        },

        gatewayMaximumUsers: {
            type: "number"
        },

        gatewayPowerUsers: {
            type: "number"
        },

        environment: {
            type: "string"
        },

        docFinityVersion: {
            type: "string"
        }

    }
})
